var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55554 9.75C5.55554 6.02208 8.57762 3 12.3055 3C16.0335 3 19.0555 6.02208 19.0555 9.75V13.6972L20.8876 16.4453C21.0922 16.7522 21.1112 17.1467 20.9372 17.4719C20.7632 17.797 20.4243 18 20.0555 18H4.55554C4.18675 18 3.84789 17.797 3.67387 17.4719C3.49985 17.1467 3.51892 16.7522 3.72349 16.4453L5.55554 13.6972V9.75Z",
    fill: "#FFFF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5555 21C13.6601 21 14.5555 20.1046 14.5555 19H10.5555C10.5555 20.1046 11.451 21 12.5555 21Z",
    fill: "#FFFF00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFilled);
export default __webpack_public_path__ + "static/media/BellFilled.2c7d479d.svg";
export { ForwardRef as ReactComponent };